import OverallDevelopmentSkill from './model';

export default OverallDevelopmentSkill;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/template/skills/index.js